import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { fromEvent, Subscription, timer } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[touchLongPress]'
})
export class TouchLongPressDirective implements OnInit, OnDestroy {
  @Input() duration = 500;
  @Output() longPress = new EventEmitter<void>();

  sub!: Subscription;

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    const touchstart$ = fromEvent(this.el.nativeElement, 'touchstart');
    const touchEnd$ = fromEvent(this.el.nativeElement, 'touchend');
    this.sub = touchstart$
      .pipe(switchMap(() => timer(this.duration).pipe(takeUntil(touchEnd$))))
      .subscribe(() => this.longPress.emit());
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
